var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mx-auto",attrs:{"height":"100","max-width":"200","outlined":""}}),_c('v-card',{staticClass:"mt-n12 mx-auto",attrs:{"elevation":"12","height":"200","max-width":"300"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }